import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';

import type { SizeSet } from '@nucleus-commerce/api-client/admin';

import { sizeSetsApi } from '../api/size-sets-api';

import { dictionaryKeys } from './dictionary-keys';

export function sizeSetQueryOptions(id: string) {
  return queryOptions({
    queryKey: dictionaryKeys.sizeSet(id),
    queryFn: () => sizeSetsApi.get(id),
    staleTime: 5 * 60_000,
  });
}

/** One size set; the list carries every set with its sizes, so a cached list seeds it. */
export function useSizeSet(id: string) {
  const queryClient = useQueryClient();
  return useQuery({
    ...sizeSetQueryOptions(id),
    initialData: () =>
      queryClient.getQueryData<SizeSet[]>(dictionaryKeys.sizeSets())?.find((row) => row.id === id),
    initialDataUpdatedAt: () => queryClient.getQueryState(dictionaryKeys.sizeSets())?.dataUpdatedAt,
  });
}
